import { DocumentNode, gql } from '@apollo/client'

export const GET_TASK_NOTES_BY_PARENTS: DocumentNode = gql`
    query GetTaskNotesByParent($daycareId: Int!, $parentIds: [Int], $from: Date, $to: Date) {
        getTaskNotesByParent(daycareId: $daycareId, parentIds: $parentIds, from: $from, to: $to) {
            id
            daycareId
            title
            description
            type
            status
            internalNote
            date
            startHour
            endHour
            userIds {
                id
                name
                isParent
            }
            childIds {
                id
                name
            }
            creationDate
            updateDate
        }
    }
`

export const GET_TASK_NOTES_BY_CHILDS: DocumentNode = gql`
    query GetTaskNotesByChild($daycareId: Int!, $childIds: [Int], $from: Date, $to: Date) {
        getTaskNotesByChild(daycareId: $daycareId, childIds: $childIds, from: $from, to: $to) {
            id
            daycareId
            title
            description
            type
            status
            internalNote
            date
            startHour
            endHour
            userIds {
                id
                name
                isParent
            }
            childIds {
                id
                name
            }
            creationDate
            updateDate
        }
    }
`

export const GET_TASK_NOTES_BY_STAFFS: DocumentNode = gql`
    query GetTaskNotesByStaff($daycareId: Int!, $staffIds: [Int], $from: Date, $to: Date) {
        getTaskNotesByStaff(daycareId: $daycareId, staffIds: $staffIds, from: $from, to: $to) {
            id
            daycareId
            title
            description
            type
            status
            internalNote
            date
            startHour
            endHour
            userIds {
                id
                name
                isParent
            }
            childIds {
                id
                name
            }
            creationDate
            updateDate
        }
    }
`

export const GET_TASK_NOTES_BY_DAYCARE: DocumentNode = gql`
    query GetTaskNotesByDaycare($daycareId: Int!, $from: Date, $to: Date) {
        getTaskNotesByDaycare(daycareId: $daycareId, from: $from, to: $to) {
            id
            daycareId
            title
            description
            type
            status
            internalNote
            date
            startHour
            endHour
            userIds {
                id
                name
                isParent
            }
            childIds {
                id
                name
            }
            creationDate
            updateDate
        }
    }
`

export const GET_TASK_NOTES_FOR_PROFILE: DocumentNode = gql`
    query GetTaskNotesForProfile($daycareId: Int!, $parentId: Int, $childId: Int, $staffId: Int) {
        getTaskNotesForProfile(daycareId: $daycareId, parentId: $parentId, childId: $childId, staffId: $staffId) {
            daycareId
            count
            taskNotes {
                id
                daycareId
                title
                description
                type
                status
                internalNote
                date
                startHour
                endHour
                userIds {
                    id
                    name
                    isParent
                }
                childIds {
                    id
                    name
                }
                creationDate
                updateDate
            }
        }
    }
`
